import React from 'react';
import { Link } from 'react-router-dom';

import "styles/card.scss";
import "./About.scss";

const About : React.FC = () => {
    return (
    <div className="about">
        <AboutData />
    </div>
    );
};

const AboutData : React.FC = () => (
<>
    <div className="about__row">
        <div className="about__image">
            <img
                className="card"
                src={process.env.PUBLIC_URL + "/assets/images/me-about.png"}
                alt="Me"
            />
        </div>
        <div className="card about__info">
            <h2> About me </h2>
            <p>
            My name is Alexander (max_hha) Degtyarev. I am a <strong>junior frontend developer</strong> and a game creator.
            I started to learn programming when i was at secondary school.
            Currently, i am learning <strong>Software Engineering in Bauman Moscow State Technical University</strong>.
            I enjoy engineering something, creating step by step complex relationships in large systems.
            </p>
        </div>
    </div>
    <div className="about__row">
        <div className="card about__info">
            <h2> Works </h2>
            <p>
            I make websites, single page applications and small games, learn modern frontend and backend techonlogies.
            You can see my works in <Link to="/projects">Projects</Link>.
            </p>
        </div>
    </div>
    <div className="about__row">
        <div className="card about__info">
            <h2> I use </h2>
            <ul>
                <li>
                    <strong>React</strong>, <strong>Typescrpit</strong>, <strong>SCSS</strong>, <strong>Relay</strong>, sometimes <strong>Bootstrap</strong> for single page applications.
                </li>
                <li>
                    <strong>Express</strong> and <strong>MongoDB</strong> or <strong>MariaDB</strong> for server side of my websites.
                </li>
                <li>
                    <strong>Godot</strong> as game engine or write small games from scratch on <strong>Pixilang</strong>
                </li>
                <li>
                    <strong>Krita</strong>, <strong>Piskel</strong>, <strong>Pixly</strong> for graphics.
                </li>
                <li>
                    <strong>Sunvox</strong> and <strong>Audacity</strong> for musics and sounds
                </li>
            </ul>
        </div>
    </div>
</>
)

export default About;
